import * as tslib_1 from "tslib";
import styled from 'styled-components';
var FormItemContent = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  flex: 1;\n  padding-top: 12px;\n  font-size: 1rem;\n  & > * {\n    font-size: 1rem;\n  }\n"], ["\n  flex: 1;\n  padding-top: 12px;\n  font-size: 1rem;\n  & > * {\n    font-size: 1rem;\n  }\n"])));
export default FormItemContent;
var templateObject_1;
//# sourceMappingURL=FormItemContent.js.map